<div>
  <label class="form-label" [for]="key">{{labelMarker | translate}}</label>
  <input type="text" [id]="key" [formControl]="control" class="form-control">
  <button *ngIf="setting.override" class="btn btn-primary mt-2" type="button"
             (click)="reset()">
    {{'lang.globals.reset' | translate}}
  </button>
</div>
